import Badges from './../requests/apa/Badges';
import getAppConfig from './../config/appConfig';

function getUserType(isLoggedIn, isSusc) {
  let userType = 'anonymous';

  if (isLoggedIn) {
    userType = isSusc ? 'susc' : 'no_susc';
  }

  return userType;
}

function getBadges(user, provider, format_types, live_enabled) {
  console.log('********[Badges] getBadges')
  if (!user || typeof provider === 'undefined' || typeof  format_types === 'undefined' || typeof live_enabled === 'undefined') {
    return '';
  }

  let badges = '';
  const config = getAppConfig();
  const userType = getUserType(user.isLoggedIn, user.isSusc);

  const formatTypes = (typeof format_types === 'object') ? format_types : format_types.split(',');
  const type = live_enabled === '1' ? 'live' : 'vod';

  if (provider === 'AMCO') {
    provider = 'default';
  }

  if (Badges.data
    && Badges.data[userType]
    && Badges.data[userType][provider]
  ) {
    for (let i = 0; i < formatTypes.length; i++) {
      if (Badges.data[userType][provider][formatTypes[i]]
        && Badges.data[userType][provider][formatTypes[i]][type]
      ) {
        const data = Badges.data[userType][provider][formatTypes[i]][type];
        for (let i = 0; i < data.length; i++) {
          badges += data[i].render;
        }
      }
    }
  }

  return badges;
}

export default getBadges;



// WEBPACK FOOTER //
// ./src/utils/Badges.js